import { gql } from '@apollo/client';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';
import { VideoType } from '../../common/helpers/domain/videoTypes';
import { ImageData, Tag } from '../fragments/project';
import { Author } from '../contentPage/postDetail';

export const PROJECT_ARTICLES_QUERY = gql`
  query ($id: Int, $exclude: Int) {
    projectArticles: posts(
      request: { perPage: 20, custom: { project: [$id] }, exclude: [$exclude] }
    ) {
      items {
        id
        postCategory
        link
        videoType
        propertyType
        title
        tags {
          id
          name
          link
        }
        featuredImage {
          url
          title
          width
          height
        }
        author {
          id
          nickname
          name
          link
          profileImage {
            url
            title
            width
            height
          }
        }
        totalComments
        embedVideo
      }
    }
  }
`;

export interface Article {
  id: number;
  postCategory: PostSubcategory;
  link: string;
  videoType: VideoType;
  propertyType: string[];
  title: string;
  tags: Tag[];
  featuredImage: ImageData;
  author: Author;
  totalComments: number;
  embedVideo: string | null;
}

export interface ProjectArticleData {
  projectArticles: {
    items: Article[];
  };
}
